import React, { useState, MouseEvent } from 'react';
import Terminal, { ColorMode, TerminalInput, TerminalOutput } from 'react-terminal-ui';


function calculateAge(birthDateString) {
  // Convert the birth date string to a Date object
  const birthDate = new Date(birthDateString);

  // Get today's date
  const today = new Date();

  // Calculate the initial age by subtracting the birth year from the current year
  let age = today.getFullYear() - birthDate.getFullYear();

  // Adjust the age if the birthday hasn't occurred yet this year
  const monthDifference = today.getMonth() - birthDate.getMonth();
  const dayDifference = today.getDate() - birthDate.getDate();

  // If the current month is before the birth month, or if it's the same month but the current day is before the birth day,
  // the person hasn't had their birthday yet this year, so subtract 1 from the age.
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }

  return age;
}

const TerminalController = (props = {}) => {
  const [colorMode, setColorMode] = useState(ColorMode.Dark);
  const [lineData, setLineData] = useState([
    <TerminalOutput>Welcome to my Site!&#128075;</TerminalOutput>,
    <TerminalOutput></TerminalOutput>,
    <TerminalOutput>Name: Dane Pedersen</TerminalOutput>,
    <TerminalOutput>Occupation: Software Engineer</TerminalOutput>,
    <TerminalOutput>Location: Denver/Nashville</TerminalOutput>,
    // <TerminalOutput>Age: {calculateAge('1998-08-15')}</TerminalOutput>,
    <TerminalOutput>Skills: Python, C#, Blazor, React, Vue, Postgres, API Development, AWS, Docker</TerminalOutput>,
  ]);

  function toggleColorMode (e) {
    e.preventDefault();
    setColorMode(colorMode === ColorMode.Light ? ColorMode.Dark : ColorMode.Light);
  }

  function onInput(input) {
      let ld = [...lineData];
      ld.push(<TerminalInput>{input}</TerminalInput>);
      if (input.toLocaleLowerCase().trim() === "view-react-docs") {
          window.open(
              "https://reactjs.org/docs/getting-started.html",
              "_blank"
          );
      } else if (input.toLocaleLowerCase().trim() === "clear") {
          ld = [];
      } else if (input) {
          ld.push(<TerminalOutput>Unrecognized command</TerminalOutput>);
      }
      setLineData(ld);
  }

  const redBtnClick = () => {
    console.log("Clicked the red button.");
  }

  const yellowBtnClick = () => {
    console.log("Clicked the yellow button.");
  }

  const greenBtnClick = () => {
    console.log("Clicked the green button.");
  }

  const btnClasses = ['btn'];
  if (colorMode === ColorMode.Light) {
    btnClasses.push('btn-dark');
  } else {
    btnClasses.push('btn-light');
  }
  return (
    <div className="container" >
      <div className="d-flex flex-row-reverse p-2">
        {/* <button className={ btnClasses.join(' ') } onClick={ toggleColorMode } >Enable { colorMode === ColorMode.Light ? 'Dark' : 'Light' } Mode</button> */}
      </div>
      <Terminal 
        name="Portfolio" 
        colorMode={ colorMode }  
        onInput={ onInput } 
        redBtnCallback={ redBtnClick } 
        yellowBtnCallback={ yellowBtnClick } 
        greenBtnCallback={ greenBtnClick }
      >
        {lineData}
      </Terminal>
    </div>
  )
};

export default TerminalController